<div class="drop-shadow-card flex h-full flex-col rounded-xl bg-white">
  <div class="bg-theme-gray-900 flex h-full min-h-0 max-w-full rounded-lg">
    <div class="flex min-w-0 grow flex-row rounded-lg">
      <ct-shared-preview-tool-bar
        [currentPageIndex]="currentPagePreviewIndex()"
        [currentPage]="currentPage()!"
        [totalPageCount]="totalPageCount()"
        [foundWordsCount]="searchService.foundWords()?.length"
        [fitType]="fitType()"
        (toggleFitType)="onToggleFit()"
        (zoomChange)="onChangeZoom($event)"
        (searchQueried)="onSearchQueried($event)"
        (searchClear)="onSearchCleared()">
        <ng-content />
      </ct-shared-preview-tool-bar>
      <div
        class="border-theme-gray-900 flex h-full w-full flex-col [align-items:safe_center] overflow-auto p-4"
        id="img-container"
        waIntersectionObserver
        (scrollend)="imageContainerScrollEnd.emit()"
        #pageImageContainer>
        @for (document of documents(); track document.id) {
          @if ($index > 0 && !isSingleDocumentView()) {
            <ct-shared-document-preview-separator
              class="sticky left-0 w-full"
              [splitFunctionality]="splitFunctionality()"
              [document]="document"
              [documentIndex]="$index"
              [documentSeparatorLabelTemplate]="documentSeparatorLabelTemplate()" />
          }
          @for (page of document.pages; track page.id; let pageIndex = $index) {
            @if (!$first) {
              <ct-shared-page-preview-separator
                class="sticky left-0 w-full"
                [document]="document"
                [splitIndex]="pageIndex"
                [pageSeparatorLabelTemplate]="pageSeparatorLabelTemplate()" />
            }

            <div
              #pageImage
              class="relative shrink-0"
              [style.aspect-ratio]="getAspectRatio(page.id)"
              [ngStyle]="getPageContainerStyle()">
              <ct-shared-document-page-preview
                class="w-full"
                [document]="document"
                [page]="page"
                [fitType]="fitType()"
                [zoom]="currentZoom()"
                (pageIntersection)="onPageIntersectionChanged(page.id, $event)" />
              @if (pageOverlayTemplate()) {
                <ng-container
                  [ngTemplateOutlet]="pageOverlayTemplate() ?? null"
                  [ngTemplateOutletContext]="{
                    $implicit: page,
                  }" />
              }
              <ct-shared-search-result-overlay
                class="pointer-events-none absolute top-0 left-0 h-full w-full"
                [pageId]="page.id" />
            </div>
          }
        }
      </div>
    </div>
    <div
      class="relative"
      (mouseenter)="isPreviewListHovered.set(true)"
      (mouseleave)="isPreviewListHovered.set(false)">
      <ct-shared-preview-thumbnail-bar
        [documentClassFilterEnabled]="documentClassFilterEnabled()"
        [availableDocumentClasses]="availableDocumentClasses()"
        [isPreviewListExpandedOrHovered]="isPreviewListExpanded() || isPreviewListHovered()"
        [documents]="documents()"
        [_currentPageIndex]="currentPagePreviewIndex()!"
        [selectedDocumentId]="selectedDocumentId()!"
        [isSingleDocumentView]="isSingleDocumentView()"
        [singleOpenedDocument]="singleOpenedDocument()"
        [documentLabelTemplate]="documentLabelTemplate()"
        [documentThumbnailOverlayTemplate]="documentThumbnailOverlayTemplate()"
        [(selectedDocumentClasses)]="selectedDocumentClasses"
        (thumbnailPageSelected)="selectPage($event, true)"
        (documentThumbnailSelected)="documentThumbnailSelected.emit($event)" />
      <button
        (click)="togglePreviewList()"
        data-testid="toggle-preview-list-button"
        [ngClass]="
          isPreviewListHovered() ? 'opacity-100' : isPreviewListExpanded() ? 'opacity-0' : ''
        "
        class="group absolute top-4 -left-3 z-10 flex items-center justify-center rounded-full border border-zinc-500 bg-zinc-600 text-white transition-all duration-500 hover:bg-zinc-500 hover:opacity-100">
        @if (isPreviewListExpanded()) {
          <span class="material-icons">keyboard_arrow_left</span>
        } @else {
          <span class="material-icons">keyboard_arrow_right</span>
        }
      </button>
    </div>
  </div>
</div>
